'use strict';

exports.__esModule = true;
exports.default = exports.SocialIcons = exports.SocialIcon = undefined;

var _socialIcon = require('./social-icon');

var _socialIcon2 = _interopRequireDefault(_socialIcon);

var _socialIcons = require('./social-icons');

var _socialIcons2 = _interopRequireDefault(_socialIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SocialIcon = _socialIcon2.default;
exports.SocialIcons = _socialIcons2.default;
exports.default = _socialIcons2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-social-icons/lib/react-social-icons.js
// module id = 175
// module chunks = 168096499685866 201563372448855